import React from 'react'
import styled from 'styled-components'

export const S_BBCUploadMessage = styled.div`
  max-width: 800px;
  text-align: center;

  h2 {
    margin-bottom: 20px;
  }

  p {
    font-size: 16;
    line-height: 150%;
  }

  .csv-format-example {
    margin-top: 15px;
  }

  .csv-format-table {
    border: 1px solid #ccc;
    border-radius: 3px;
    text-align: left;
    margin: 20px auto 0;
  }

  .cell {
    padding: 5px 10px;
  }
`

const messages = {
  default: {
    title: 'Error Uploading Files',
    text: 'There was an issue uploading your files, please try again.',
  },
  'csv-only': {
    title: 'Error Uploading Invoices',
    text: 'Please upload schedules in .CSV format. You can upload supporting files later in the Borrowing Base Submission.',
  },
  'csv-format': {
    title: 'Error Uploading Invoices',
    text: 'Make sure your .CSV files are in the correct format.',
  },
  'csv-help': {
    title: 'Formatting .CSV Files',
  },
}

const csvHeaders = [
  'Debtor ID',
  'Debtor Name',
  'Invoice #',
  'Purchase Order',
  'Invoice Date',
  'Terms',
  'Amount',
  'Fund',
]
const csvRows = [
  ['1', 'Debtor 1', ' 000001', '1', '2020-01-01', '30', '123.45', ''],
  ['2', 'Debtor 2', ' 000002', '2', '2020-01-01', '30', '999.99', ''],
]

export const BBCUploadMessage = ({ message = 'default' }) => {
  const m = messages[message] || messages['default']
  const { title, text } = m
  return (
    <S_BBCUploadMessage>
      <h2>{title}</h2>
      {text && <p>{text}</p>}
      {(message === 'csv-format' || message === 'csv-help') && (
        <div className="csv-format-example">
          Use the following format for uploading .CSV schedules
          <table className="csv-format-table">
            <tr>
              {csvHeaders.map((csvHeader) => (
                <th className="cell" key={csvHeader}>
                  {csvHeader}
                </th>
              ))}
            </tr>
            {csvRows.map((csvRow, i) => (
              <>
                <tr key={i}>
                  {csvRow.map((csvValue) => (
                    <td className="cell" key={csvValue}>
                      {csvValue}
                    </td>
                  ))}
                </tr>
              </>
            ))}
            {csvRows.map((csvRow, i) => (
              <>
                <tr key={i}>
                  {csvRow.map((csvValue) => (
                    <td className="cell" key={csvValue}>
                      ...
                    </td>
                  ))}
                </tr>
              </>
            ))}
          </table>
        </div>
      )}
    </S_BBCUploadMessage>
  )
}
